import { useMemo } from 'preact/hooks';

import { usePlayerContainer } from './usePlayerContainer';

export const usePreviewElement = () => {
  const playerContainer = usePlayerContainer();

  return useMemo(() => {
    return playerContainer.querySelector<HTMLDivElement>('.jw-preview');
  }, [playerContainer]);
};
